<!--
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-01-15 11:24:49
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-07-23 15:14:49
 * @FilePath: \crm-product\found\views\mdm\views\customer_information\components\extended_info\productLevel\productLevel.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<script>
import TablePage from '../../../../../../../components/table_page';
import configs from './config';

export default {
  extends: TablePage,
  props: {
    data: Array,
    dataType: String,
    selectKeys: Array,
  },
  data() {
    return {
      requestUrl: '/mdm/mdmProductLevelController/pageList',
      configs,
      // checkStrictly: true,
    };
  },
  created() {
    // this.init();
    // configs.pagination = false;
  },
  beforeMount() {
  },
  methods: {
    afterCheckboxChange() {
      this.$emit('onSelect', this.selectRow);
    },
    afterCheckAllChange(val) {
      this.$emit('onSelect', val.selection);
    },
    async init() {
      await this.getConfigList('terminal_product_level', true, true);
    },
    afterGetList() {
      this.selection = this.selectKeys || [];
    },
  },

};
</script>

<style>

</style>
